<template>
    <div>
        <TitleImage image="home" title="Escuela Técnica N°2 Olavarría" />    
        <div class="col-md-9 col-sm-12 container">
            <QuickAccess />
            <Notices :inSection="true" :limit="6" />
        </div>
        <Contact />
    </div>
</template>

<script>
import TitleImage from '@/components/TitleImage'
import QuickAccess from '@/components/QuickAccess'
import Notices from '@/components/Notices'
import Contact from '@/components/Contact'

export default {
    components:{
        TitleImage,
        QuickAccess,
        Notices,
        Contact,
    }
}
</script>

